import React from 'react'
import Layout from '../Layout'

export default function PrivacyPolicy(props) {
    return (
        <Layout props={props}>
            <div className=" py-4  staticPgWrapper">
                {/* <h2>About Us</h2> */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: global.storeDetails.privacy_policy,
                    }}
                ></span>
            </div>
        </Layout>
    )
}
